module.exports = __webpack_public_path__ + "static/og-image-ea3245b05de0f30db4beb1316836bc39.jpg";